(function(e, a) { for(var i in a) e[i] = a[i]; }(exports, /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(3);


/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("node-polyglot");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

var amdi18n={"__root":{"codeSnippetCopy":"Copy","codeSnippetCopied":"Copied","codeSnippetCopyText":"Copy text","codeSnippetShowLess":"Show less","codeSnippetShowMore":"Show more","numberInputDecrement":"Decrement number","numberInputIncrement":"Increment number"},"__cs":{"codeSnippetCopy":"Kopírovat","codeSnippetCopied":"Zkopírováno","codeSnippetCopyText":"Kopírovat text","codeSnippetShowLess":"Zobrazit méně","codeSnippetShowMore":"Zobrazit více","numberInputDecrement":"Snížit číslo","numberInputIncrement":"Zvýšit číslo"},"__da":{"codeSnippetCopy":"Kopiér","codeSnippetCopied":"Kopieret","codeSnippetCopyText":"Kopiér tekst","codeSnippetShowLess":"Vis mindre","codeSnippetShowMore":"Vis mere","numberInputDecrement":"Tal for reduktion","numberInputIncrement":"Tal for forøgelse"},"__de":{"codeSnippetCopy":"Kopieren","codeSnippetCopied":"Kopiert","codeSnippetCopyText":"Text kopieren","codeSnippetShowLess":"Weniger anzeigen","codeSnippetShowMore":"Mehr anzeigen","numberInputDecrement":"Zahl reduzieren","numberInputIncrement":"Zahl erhöhen"},"__es":{"codeSnippetCopy":"Copiar","codeSnippetCopied":"Copiado","codeSnippetCopyText":"Copiar texto","codeSnippetShowLess":"Visualizar menos","codeSnippetShowMore":"Visualizar más","numberInputDecrement":"Disminuir número","numberInputIncrement":"Incrementar número"},"__fi":{"codeSnippetCopy":"Kopioi","codeSnippetCopied":"Kopioitu","codeSnippetCopyText":"Kopioi teksti","codeSnippetShowLess":"Näytä vähemmän","codeSnippetShowMore":"Näytä enemmän","numberInputDecrement":"Pienennä lukua","numberInputIncrement":"Suurenna lukua"},"__fr":{"codeSnippetCopy":"Copier","codeSnippetCopied":"Copié","codeSnippetCopyText":"Copier un texte","codeSnippetShowLess":"Afficher moins","codeSnippetShowMore":"Afficher d'autres lignes","numberInputDecrement":"Diminuer le nombre","numberInputIncrement":"Augmenter le nombre"},"__hr":{"codeSnippetCopy":"Kopiraj","codeSnippetCopied":"Kopirano","codeSnippetCopyText":"Kopiraj tekst","codeSnippetShowLess":"Pokaži manje","codeSnippetShowMore":"Pokaži više","numberInputDecrement":"Smanji broj","numberInputIncrement":"Povećaj broj"},"__hu":{"codeSnippetCopy":"Másolás","codeSnippetCopied":"Átmásolva","codeSnippetCopyText":"Szöveg másolása","codeSnippetShowLess":"Részletek elrejtése","codeSnippetShowMore":"Részletek megjelenítése","numberInputDecrement":"Szám csökkentése","numberInputIncrement":"Szám növelése"},"__it":{"codeSnippetCopy":"Copia","codeSnippetCopied":"Copiato","codeSnippetCopyText":"Copia testo","codeSnippetShowLess":"Mostra meno","codeSnippetShowMore":"Mostra altro","numberInputDecrement":"Decrementa numero","numberInputIncrement":"Incrementa numero"},"__ja":{"codeSnippetCopy":"コピー","codeSnippetCopied":"コピーされました","codeSnippetCopyText":"テキストのコピー","codeSnippetShowLess":"簡略表示","codeSnippetShowMore":"詳細表示","numberInputDecrement":"減分数","numberInputIncrement":"増分数"},"__kk":{"codeSnippetCopy":"Көшіру","codeSnippetCopied":"Көшірілген","codeSnippetCopyText":"Мәтінді көшіру","codeSnippetShowLess":"Азырақ көрсету","codeSnippetShowMore":"Қосымша көрсету","numberInputDecrement":"Төмендету нөмірі","numberInputIncrement":"Өсім саны"},"__ko":{"codeSnippetCopy":"복사","codeSnippetCopied":"복사됨","codeSnippetCopyText":"텍스트 복사","codeSnippetShowLess":"표시 수 줄이기","codeSnippetShowMore":"표시 수 늘리기","numberInputDecrement":"감소 수","numberInputIncrement":"증분 수"},"__nb":{"codeSnippetCopy":"Kopier","codeSnippetCopied":"Kopiert","codeSnippetCopyText":"Kopier tekst","codeSnippetShowLess":"Vis mindre","codeSnippetShowMore":"Vis mer","numberInputDecrement":"Reduser tall","numberInputIncrement":"Øk tall"},"__nl":{"codeSnippetCopy":"Kopiëren","codeSnippetCopied":"Gekopieerd","codeSnippetCopyText":"Tekst kopiëren","codeSnippetShowLess":"Minder afbeelden\n","codeSnippetShowMore":"Meer afbeelden\n","numberInputDecrement":"Getal verlagen","numberInputIncrement":"Getal verhogen"},"__no":{"codeSnippetCopy":"Kopier","codeSnippetCopied":"Kopiert","codeSnippetCopyText":"Kopier tekst","codeSnippetShowLess":"Vis mindre","codeSnippetShowMore":"Vis mer","numberInputDecrement":"Reduser tall","numberInputIncrement":"Øk tall"},"__pl":{"codeSnippetCopy":"Kopiuj","codeSnippetCopied":"Skopiowano","codeSnippetCopyText":"Kopiuj tekst","codeSnippetShowLess":"Pokaż mniej","codeSnippetShowMore":"Pokaż więcej","numberInputDecrement":"Zmniejsz numer o jeden","numberInputIncrement":"Zwiększ numer o jeden"},"__pt":{"codeSnippetCopy":"Copiar","codeSnippetCopied":"Copiado","codeSnippetCopyText":"Copiar o texto","codeSnippetShowLess":"Mostrar menos","codeSnippetShowMore":"Mostrar mais","numberInputDecrement":"Número de decrementos","numberInputIncrement":"Número de incrementos"},"__pt-br":{"codeSnippetCopy":"Copiar","codeSnippetCopied":"Copiado","codeSnippetCopyText":"Copiar o texto","codeSnippetShowLess":"Mostrar menos","codeSnippetShowMore":"Mostrar mais","numberInputDecrement":"Número de decrementos","numberInputIncrement":"Número de incrementos"},"__ro":{"codeSnippetCopy":"Copiere","codeSnippetCopied":"Copiat","codeSnippetCopyText":"Copiere text","codeSnippetShowLess":"Afişare mai puţin","codeSnippetShowMore":"Afişare mai mult","numberInputDecrement":"Număr decrementare ","numberInputIncrement":"Număr incrementare "},"__ru":{"codeSnippetCopy":"Копировать","codeSnippetCopied":"Скопировано","codeSnippetCopyText":"Копировать текст","codeSnippetShowLess":"Показать меньше","codeSnippetShowMore":"Показать больше","numberInputDecrement":"Номер уменьшения","numberInputIncrement":"Номер приращения"},"__sl":{"codeSnippetCopy":"Prekopiraj","codeSnippetCopied":"Prekopirano","codeSnippetCopyText":"Prekopiraj besedilo","codeSnippetShowLess":"Pokaži manj","codeSnippetShowMore":"Pokaži več","numberInputDecrement":"Zmanjšaj število","numberInputIncrement":"Povečaj število"},"__sv":{"codeSnippetCopy":"Kopiera","codeSnippetCopied":"Kopierad","codeSnippetCopyText":"Kopiera text","codeSnippetShowLess":"Visa färre","codeSnippetShowMore":"Visa fler","numberInputDecrement":"Minska nummer","numberInputIncrement":"Öka nummer"},"__th":{"codeSnippetCopy":"คัดลอก","codeSnippetCopied":"คัดลอกแล้ว","codeSnippetCopyText":"คัดลอกข้อความ","codeSnippetShowLess":"แสดงลดลง","codeSnippetShowMore":"แสดงเพิ่มขึ้น","numberInputDecrement":"จำนวนที่ลดลง","numberInputIncrement":"จำนวนที่เพิ่มขึ้น"},"__tr":{"codeSnippetCopy":"Kopyala","codeSnippetCopied":"Kopyalandı","codeSnippetCopyText":"Metni kopyala","codeSnippetShowLess":"Daha az göster","codeSnippetShowMore":"Daha fazla göster","numberInputDecrement":"Azalış sayısı","numberInputIncrement":"Artış sayısı"},"__zh":{"codeSnippetCopy":"复制","codeSnippetCopied":"已复制","codeSnippetCopyText":"复制文本","codeSnippetShowLess":"显示更少内容","codeSnippetShowMore":"显示更多内容","numberInputDecrement":"减量数量","numberInputIncrement":"增量数量"},"__zh-cn":{"codeSnippetCopy":"复制","codeSnippetCopied":"已复制","codeSnippetCopyText":"复制文本","codeSnippetShowLess":"显示更少内容","codeSnippetShowMore":"显示更多内容","numberInputDecrement":"减量数量","numberInputIncrement":"增量数量"},"__zh-hk":{"codeSnippetCopy":"複製","codeSnippetCopied":"已複製","codeSnippetCopyText":"複製文字","codeSnippetShowLess":"顯示更少","codeSnippetShowMore":"顯示更多","numberInputDecrement":"減量數","numberInputIncrement":"增量數"},"__zh-mo":{"codeSnippetCopy":"複製","codeSnippetCopied":"已複製","codeSnippetCopyText":"複製文字","codeSnippetShowLess":"顯示更少","codeSnippetShowMore":"顯示更多","numberInputDecrement":"減量數","numberInputIncrement":"增量數"},"__zh-sg":{"codeSnippetCopy":"复制","codeSnippetCopied":"已复制","codeSnippetCopyText":"复制文本","codeSnippetShowLess":"显示更少内容","codeSnippetShowMore":"显示更多内容","numberInputDecrement":"减量数量","numberInputIncrement":"增量数量"},"__zh-tw":{"codeSnippetCopy":"複製","codeSnippetCopied":"已複製","codeSnippetCopyText":"複製文字","codeSnippetShowLess":"顯示更少","codeSnippetShowMore":"顯示更多","numberInputDecrement":"減量數","numberInputIncrement":"增量數"}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "node-polyglot"
var external_node_polyglot_ = __webpack_require__(1);
var external_node_polyglot_default = /*#__PURE__*/__webpack_require__.n(external_node_polyglot_);

// CONCATENATED MODULE: ./src/nls/utils/StringResource.js
/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// import * as polyglot from 'polyglot';


const StringResource = function (resources) {
  const allResources = Object.assign({}, resources);
  this._polyglot = new external_node_polyglot_default.a({
    phrases: allResources
  });
};
/**
 * Get the string resource for the given key and interpolation options
 *
 * @param key The  key of the string to return
 * @param interpolationOptions Optional interpolation options (see poly.t documentation for details)
 * @returns The string to display
 */


StringResource.prototype.get = function (key, interpolationOptions) {
  let translated = this._polyglot.t(key, interpolationOptions);

  if (this._polyglot.phrases[key] === undefined) {
    translated = `__NOT_TRANSLATED__(${key})`;
  }

  return translated;
};


// EXTERNAL MODULE: ./node_modules/amdi18n-loader!./src/nls/CarbonResources.js
var CarbonResources = __webpack_require__(2);
var CarbonResources_default = /*#__PURE__*/__webpack_require__.n(CarbonResources);

// CONCATENATED MODULE: ./src/nls/StringResource.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stringResource", function() { return stringResource; });
/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2020
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/

 // eslint-disable-line
// https://jsw.ibm.com/browse/BAUICOMMON-237

const stringResource = new StringResource(CarbonResources_default.a);

/***/ })
/******/ ])));